"use strict";

import {translate} from "./translations";

export default function ($scope) {
    let $forms = $scope.find('.js-parsley');

    if ($forms && $forms.length) {
        loadParsley().done(function () {
            Parsley.addValidator('emailInUse', {
                validateString: function(value) {
                    //todo: would it be better to use js-classes and add "data-parsley-email-in-use" dynamically?
                    let createAccountInput = $('input[name=createAccount]');
                    if (createAccountInput.length && createAccountInput.is(':checked')){
                        let xhr = $.ajax(_config.customerValidUrl, {
                            data: {email: value}
                        });

                        return xhr.then(function (result) {
                            console.log('result', result);
                            if (!result) {
                                return $.Deferred().reject(translate('demi.booking.checkout.email-in-use'));
                            } else {
                                return $.Deferred().resolve();
                            }
                        });
                    }
                }
            });


            $forms.parsley(options);

            $forms.each(function () {
                let $form = $(this);

                $form.parsley().on('field:error', function() {
                    let parsleyId = this.__id__;
                    let fieldClass = this.__class__;

                    if (fieldClass === 'ParsleyFieldMultiple') {
                        parsleyId = 'multiple-' + this.$element.data('parsley-multiple');
                    }

                    this.$element.attr({
                        'aria-invalid': "true",
                        'aria-describedby': 'parsley-id-'+ parsleyId
                    });
                });

                $form.parsley().on('field:success', function() {
                    this.$element.removeAttr('aria-invalid aria-describedby');
                });
            });
        }).fail(function (a,b,c) {
            console.error(a,b,c);
        });
    }
};

export const options = {
    successClass: 'has-success',
    errorClass: 'has-error',
    classHandler: function (_el) {
        return _el.$element.closest('.form-group, .js-form-group');
    },
    errorsContainer: function (_el) {
        let errorContainer = _el.$element.closest('.form-group, .js-form-group').find('.form-errors, .js-form-errors');
        if (errorContainer && errorContainer.length > 0) {
            return errorContainer;
        }
    },
    // nur felder validieren die sichtbar sind
    excluded: "input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], :hidden"
};

let promise;
export function loadParsley () {
    if (promise) {
        return promise;
    }

    promise = $.Deferred();

    import("parsleyjs").then(function () {
        if (_config.lang && _config.lang !== 'en') {
            import("parsleyjs/dist/i18n/" + _config.lang).then(function () {
                promise.resolve();
            }).catch(function () {
                /*fallback if there is no package*/
                promise.resolve();
            });
        } else {
            promise.resolve();
        }
    }).catch(function () {
        promise.reject();
    });

    return promise;
}

export function isParsleyForm ($form) {
    return $form.is('.js-parsley');
}

export function isValid($form) {
    if (!$form.data('Parsley')) {
        /* if the form is not initialized */
        $form.parsley(options);
    }

    return $form.data('Parsley').validate();
}
export function isValidPromise($form) {
    if (!$form.data('Parsley')) {
        /* if the form is not initialized */
        $form.parsley(options);
    }

    return $form.data('Parsley').whenValidate();
}
